import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../login/authProvider";
import { getAllCompanies } from "../api/endpoints";
import "./adminpage.css";

const AdminPage = () => {
  const { token } = useAuth();
  const [users, setUsers] = useState([]);
  const [newUserEmail, setNewUserEmail] = useState("");
  const [newUserName, setNewUserName] = useState("");
  const [newUserPhone, setNewUserPhone] = useState("");
  const [newUserCompany, setNewUserCompany] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); 
  const [activityLog, setActivityLog] = useState([]);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmAction, setConfirmAction] = useState(null);
  const [allCompanies, setAllCompanies] = useState([]);


  const API_URL = process.env.REACT_APP_API_URL;
  const ADMIN_URL = `${API_URL}/admin`;



  useEffect(() => {
    if (token) {
      fetchUsers(token);
    }
  }, [token]);

  const fetchUsers = async (token) => {
  try {
    setLoading(true);
    const response = await axios.get(`${API_URL}/admin/getAllUsers`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const sorted = response.data.sort((a, b) => {
      const companyA = (a.company || "").toLowerCase();
      const companyB = (b.company || "").toLowerCase();
      return companyA.localeCompare(companyB, "sv"); 
    });

    setUsers(sorted);
  } catch (error) {
    console.error("Kunde inte hämta användare:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const data = await getAllCompanies(token);
        setAllCompanies(data); // Vi skippar "Alla företag" i denna lista
      } catch (error) {
        console.error("Kunde inte hämta företag:", error);
      }
    };
  
    if (token) {
      fetchCompanies();
    }
  }, [token]);
  


  const openConfirmPopup = (message, action) => {
    setConfirmMessage(message);
    setConfirmAction(() => action);
    setShowConfirmPopup(true);
  };


  const closeConfirmPopup = () => {
    setShowConfirmPopup(false);
    setConfirmAction(null);
  };



  const filteredUsers = users.filter((user) =>
    user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.phone.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const normalizeEmail = (s) => (s || "").trim().toLowerCase();



const addUser = async () => {
  if (!newUserEmail || !newUserCompany || !newUserName || !newUserPhone) {
    alert("Fyll i alla fälten!");
    return;
  }

  const emailKey = normalizeEmail(newUserEmail);


  if (users.some(u => normalizeEmail(u.email) === emailKey)) {
    alert("E-postadressen finns redan.");
    return;
  }

  openConfirmPopup(`Är du säker på att du vill lägga till ${newUserName}?`, async () => {
    try {

      const res = await axios.post(`${ADMIN_URL}/addUser`, {
        email: emailKey,
        company: newUserCompany,
        name: newUserName.trim(),
        phone: newUserPhone.trim(),
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        validateStatus: () => true, 
      });

      if (res.status === 409) {
        alert("E-postadressen finns redan.");
        return;
      }
      if (res.status >= 400) {
        alert("Kunde inte skapa användaren.");
        return;
      }

    
      const mailRes = await axios.post(`${API_URL}/send-welcome-mail`, {
        name: newUserName.trim(),
        email: emailKey,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        validateStatus: () => true,
      });

      if (mailRes.status >= 400) {
        alert("Användaren lades till men välkomstmail kunde inte skickas.");
      } else {
        alert("Användare tillagd och välkomstmail skickat!");
      }

    
      setNewUserName("");
      setNewUserEmail("");
      setNewUserPhone("");
      setNewUserCompany("");
      fetchUsers(token);
      closeConfirmPopup();

    } catch (error) {
      console.error("Kunde inte lägga till användare eller skicka mail:", error);
      alert("Något gick fel när användaren skulle läggas till.");
    }
  });
};



  
  const deleteUser = async (email) => {
    openConfirmPopup(`Är du säker på att du vill ta bort användaren ${email}?`, async () => {
      try {
        await axios.delete(`${ADMIN_URL}/deleteUser/${email}`, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
  
        alert("Användare borttagen!");
        fetchUsers(token); 
        closeConfirmPopup();
      } catch (error) {
        console.error("Kunde inte ta bort användare:", error);
      }
    });
  };



const fetchActivityLog = async () => {
  try {
    const response = await axios.get(`${ADMIN_URL}/activity-log`, {
      headers: { "Authorization": `Bearer ${token}` }
    });
    setActivityLog(response.data);
  } catch (error) {
    console.error("Kunde inte hämta aktivitetsloggen:", error);
  }
};

useEffect(() => {
  if (token) {
    fetchUsers(token);
    fetchActivityLog(); 
  }
}, [token]);

  

  return (
    <div className="admin-container">
      <h2 className="adminh2">Adminpanel ⚙️</h2>


      <div className="admin-section">
        <h3>Lägg till en ny användare</h3>
 
        <input
          type="name"
          placeholder="För och efternamn"
          value={newUserName}
          onChange={(e) => setNewUserName(e.target.value)}
        />
        <input
          type="email"
          placeholder="E-postadress"
          value={newUserEmail}
          onChange={(e) => setNewUserEmail(e.target.value)}
        />
        <input
          type="phone"
          placeholder="Telefonnummer"
          value={newUserPhone}
          onChange={(e) => setNewUserPhone(e.target.value)}
        />
      <select
  className="company-select-admin"
  value={newUserCompany}
  onChange={(e) => setNewUserCompany(e.target.value)}
>
  <option value="">Välj företag</option>
  {allCompanies.map((company, index) => (
    <option key={index} value={company}>
      {company}
    </option>
  ))}
</select>

        <button className="add-btn" onClick={addUser}>Lägg till ✚</button>
      </div>


      <div className="admin-section">

   
        <h3>Alla användare</h3>

         
      <div className="search-container">
        <input
          type="text"
          placeholder="Sök efter användare eller företag..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      
        {loading ? (
          <p>Laddar användare...</p>
        ) : (
          <table className="user-table">
            <thead>
              <tr>
                <th>Företag</th>
                <th>Namn</th>
                <th>E-post</th>
                <th>Telefon</th>
                <th>Ta bort</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user, index) => (
                <tr key={user.id || index}>
                  <td data-label="Företag">{user.company}</td>
                  <td data-label="Namn">{user.name}</td>
                  <td data-label="E-post">{user.email}</td>
                  <td data-label="Telefon">{user.phone}</td>
                  <td>
                  <button className="delete-btn" onClick={() => deleteUser(user.email)}>❌</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="admin-section">
  <h3>📜 Aktivitetslogg</h3>
  <p>Här ser du de senaste åtgärderna som gjorts av andra administratörer.</p>

  {activityLog.length === 0 ? (
    <p>Ingen aktivitet registrerad ännu.</p>
  ) : (
    <table className="activity-table">
      <thead>
        <tr>
        <th style={{ width: "20%" }}>Datum & tid</th>
    <th style={{ width: "26%" }}>Admin</th>
    <th style={{ width: "54%" }}>Åtgärd</th>
        </tr>
      </thead>
      <tbody>
        {activityLog.map((log, index) => (
          <tr key={index}>
            <td data-label="Datum & tid">{new Date(log.timestamp).toLocaleString()}</td>
            <td data-label="Admin">{log.adminEmail}</td>
            <td data-label="Åtgärd">{log.action}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )}
</div>



      {showConfirmPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{confirmMessage}</p>
            <div className="popup-buttons">
              <button onClick={() => { confirmAction(); closeConfirmPopup(); }} className="confirm-btn">Ja</button>
              <button onClick={closeConfirmPopup} className="cancel-btn">Nej</button>
            </div>
          </div>
        </div>
      )}
    </div>

    
  );
  
};

export default AdminPage;
